
class Callbacks {
  static updateBilledHandlingDurationHandler(value) {
    return function updateBilledHandlingDuration(setFormValues, handling_amount, handling_slice) {
      const updates = _.compact(_.flatten([
        { field: 'assigned_transport.info.billed_handling_duration', value: handling_amount },
        { field: 'handling', value: handling_slice }
      ]))
      setFormValues(updates)
    }
  }

}

export default Callbacks
